import classNames from 'classnames';
import React, { type JSX, type ReactNode } from 'react';

import './Gallery.less';

// ==============================
// TYPES
// ==============================
type GalleryProps = {
  children: ReactNode;
  justify?: 'center';
};

// ==============================
// HELPERS
// ==============================
/** Merge GalleryCard class onto a card root (DefaultCard, div, etc.). */
function galleryCardClass(className?: string): string {
  return classNames('GalleryCard', className);
}

// ==============================
// COMPONENTS
// ==============================
function Gallery({ children, justify }: GalleryProps): JSX.Element {
  return (
    <div
      className={classNames(
        'Gallery',
        justify && `Gallery--justify-${justify}`
      )}
    >
      {children}
    </div>
  );
}

export { Gallery, galleryCardClass };
export type { GalleryProps };
